import { render, staticRenderFns } from "./ot-button-wrapper.vue?vue&type=template&id=665707e6&scoped=true&"
import script from "./ot-button-wrapper.vue?vue&type=script&lang=ts&"
export * from "./ot-button-wrapper.vue?vue&type=script&lang=ts&"
import style0 from "./ot-button-wrapper.vue?vue&type=style&index=0&id=665707e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665707e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
